module.exports = __webpack_public_path__ + "media/images/pc/stores/hamamatsu/store-hamamatsu-opening-9e22d408fe6840fed272f8abed1655f8.webp";